import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { OTPContainer } from './components/OTPContainer';
import TestimonialsTwoCarousel from './components/TestimonialsCarousel';

export const EnterTheCodeWeJustSent = () => {
  const navigate = useNavigate();
  const inputRefs = useRef<Array<any>>([]);

  const handleInputChange = (index: number, event: any) => {
    const value = event.target.value;
    if (value.length > 1) {
      event.target.value = value.slice(0, 1);
      return;
    }
    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleGoToNextPage = () => {
    navigate('/onboarding/v2/confirm-business-phone-number');
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32 }}>
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{
              width: 120,
              height: 'auto',
            }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 400,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h5"
            fontWeight={700}
            mb={2}
            mt={2}
            align="center"
            sx={{ width: '100%' }}
          >
            Enter the code we just sent
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={4}
            align="center"
            sx={{ width: '100%' }}
          >
            Check your messages and type in the 6-digit code to continue.
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={2}
            align="center"
            sx={{ width: '100%' }}
          >
            Verification code sent to +1 123 123 1234{' '}
            <Link href="#" variant="body2" color="#4949C8" underline="hover">
              change
            </Link>
          </Typography>
          <OTPContainer
            length={6}
            onChange={(value) => console.log('OTP value:', value)}
            onComplete={(value) => console.log('OTP complete:', value)}
          />
          <Box sx={{ width: '100%', maxWidth: 380, textAlign: 'left', mb: 1 }}>
            <Link
              href="#"
              color="#4949C8"
              underline="hover"
              sx={{ fontSize: 16, fontWeight: 400 }}
            >
              Resend code
            </Link>
          </Box>
          <Link
            href="#"
            color="#4949C8"
            underline="hover"
            sx={{ fontSize: 16, fontWeight: 400, mt: 3, mb: 1 }}
          >
            Sign up using email
          </Link>
          <Typography variant="body2" mt={4} textAlign="center" color="#fff">
            Already have an account?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            This is what we found about <br /> your business
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            We automatically pulled this info from your <br /> website.
          </Typography>
        </Box>
        <TestimonialsTwoCarousel />
      </Grid>
    </Grid>
  );
};
